import React, {useEffect, useRef } from 'react';
import Utils from '../utils';

function EnchantedItemResult({ item, index, term, useRaw }) {
    const componentRef = useRef(null);
    
    useEffect(() => {
        // Run doCH for the current component only
        if (componentRef.current) {
          Utils.highlightSearchTerm(componentRef.current, term);
          Utils.doCH(componentRef.current);
        }
      }, [term]); // Empty dependency array ensures this runs only once after initial render

  return (
    <li className={`result-item ${item.outputLanguage2 ? `multi` : ``}`} data-id={item.id} key={index} ref={componentRef}>
        <ul className="info-container" data-id={item.id}>
            <li>
                <span>{item.id}</span>
            </li>
        </ul>
        <ul className="language-container">
            <li>
                <strong>
                <span className={`copyable item-name class-${item.inputLanguage?.color}`}>{item.inputLanguage?.itemName}</span>
                </strong>
                {item.inputLanguage?.additional_name ? (
                <span className="copyable add-name">{item.inputLanguage.additional_name}</span>
                ) : null}
                <br />
                <br />
                <div className="table-responsive-sm">
                    <table className="table no-style">
                        <tbody>
                    {item.inputLanguage?.descriptions && Object.keys(item.inputLanguage.descriptions).map((key, index) => (
                        <tr key={index} data-id={item.id + item.inputLanguage.descriptions[key].requiredEnchant}>
                            <td>+{item.inputLanguage.descriptions[key].requiredEnchant}</td>
                            {useRaw ? (
                                <td>{item.inputLanguage.descriptions[key].text}</td>
                            ) : (
                        <td
                        dangerouslySetInnerHTML={{
                            __html: Utils.doPreview(item.inputLanguage.descriptions[key].text),
                        }}
                        ></td>
                            )}
                        </tr>
                    ))}
                    </tbody>
                    </table>
                </div>
            </li>
        </ul>
        <ul className="language-container">
            <li>
                <strong>
                <span className={`copyable item-name class-${item.outputLanguage?.color}`}>{item.outputLanguage?.itemName}</span>
                </strong>
                {item.outputLanguage?.additional_name ? (
                <span className="copyable add-name">{item.outputLanguage.additional_name}</span>
                ) : null}
                <br />
                <br />
                <div className="table-responsive-sm">
                    <table className="table no-style">
                        <tbody>
                    {item.outputLanguage?.descriptions && Object.keys(item.outputLanguage.descriptions).map((key, index) => (
                        <tr key={index} data-id={item.id + item.outputLanguage.descriptions[key].requiredEnchant}>
                            <td>+{item.outputLanguage.descriptions[key].requiredEnchant}</td>
                            {useRaw ? (
                                <td>{item.outputLanguage.descriptions[key].text}</td>
                            ) : (
                        <td
                        dangerouslySetInnerHTML={{
                            __html: Utils.doPreview(item.outputLanguage.descriptions[key].text),
                        }}
                        ></td>
                            )}
                        </tr>
                    ))}
                    </tbody>
                    </table>
                </div>
            </li>
        </ul>
        {item.outputLanguage2 ? (
            <ul className="language-container">
            <li>
                <strong>
                <span className={`copyable item-name class-${item.outputLanguage2?.color}`}>{item.outputLanguage2?.itemName}</span>
                </strong>
                {item.outputLanguage2?.additional_name ? (
                <span className="copyable add-name">{item.outputLanguage2.additional_name}</span>
                ) : null}
                <br />
                <br />
                <div className="table-responsive-sm">
                    <table className="table no-style">
                        <tbody>
                    {item.outputLanguage2?.descriptions && Object.keys(item.outputLanguage2.descriptions).map((key, index) => (
                        <tr key={index} data-id={item.id + item.outputLanguage2.descriptions[key].requiredEnchant}>
                            <td>+{item.outputLanguage2.descriptions[key].requiredEnchant}</td>
                            {useRaw ? (
                                <td>{item.outputLanguage2.descriptions[key].text}</td>
                            ) : (
                        <td
                        dangerouslySetInnerHTML={{
                            __html: Utils.doPreview(item.outputLanguage2.descriptions[key].text),
                        }}
                        ></td>
                            )}
                        </tr>
                    ))}
                    </tbody>
                    </table>
                </div>
            </li>
        </ul>
        ) : null}
    </li>
  );
}

export default EnchantedItemResult;
